import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './NavSearch.css';

const NavSearch = ({ className = '' }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [query, setQuery] = useState('');
    const containerRef = useRef(null);
    const inputRef = useRef(null);

    const goToSearch = () => {
        const trimmed = query.trim();
        if (!trimmed) return;
        setIsOpen(false);
        navigate(`/search?q=${encodeURIComponent(trimmed)}`);
    };

    const handleToggle = () => {
        setIsOpen((prev) => {
            const next = !prev;
            if (next) {
                setTimeout(() => inputRef.current?.focus(), 150);
            }
            return next;
        });
    };

    const handleClose = () => {
        setIsOpen(false);
        setQuery('');
    };

    useEffect(() => {
        if (!isOpen) return undefined;

        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                handleClose();
            }
        };

        const handleEscape = (event) => {
            if (event.key === 'Escape') handleClose();
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isOpen]);

    return (
        <li className={`nav-item Center nav-search-item ${className}`} ref={containerRef}>
            <div className={`nav-search ${isOpen ? 'nav-search--open' : ''}`}>
                <button
                    type="button"
                    className="nav-search-toggle"
                    onClick={handleToggle}
                    aria-label={t('Search.Nav.Toggle')}
                    aria-expanded={isOpen}
                >
                    <FontAwesomeIcon icon={isOpen ? faTimes : faSearch} />
                </button>
                <div className="nav-search-field-wrap">
                    <input
                        ref={inputRef}
                        type="search"
                        className="nav-search-input m-1"
                        placeholder={t('Search.Nav.Placeholder')}
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                goToSearch();
                            }
                        }}
                        aria-label={t('Search.Nav.Placeholder')}
                    />
                    <button
                        type="button"
                        className="nav-search-submit"
                        onClick={goToSearch}
                        disabled={!query.trim()}
                        aria-label={t('Search.Nav.Submit')}
                    >
                        <FontAwesomeIcon icon={faSearch} />
                    </button>
                </div>
            </div>
        </li>
    );
};

export default NavSearch;
